import React from 'react';

import Skeleton, { SKELETON_WIDTHS } from 'buyside/components/presentation/Skeleton/skeleton';

import styles from 'buyside/components/presentation/IdeaUpdates/IdeaUpdateCard/ideaUpdateCardStyles.scss';

const IdeaUpdateCardLoading: React.FC = () => (
  <div className={styles.ideaUpdateCard}>
    <div className={styles.leftRow}>
      <Skeleton />
    </div>
    <div className={styles.rightRow}>
      <div className={styles.updateBody}>
        <Skeleton width={SKELETON_WIDTHS.FULL} />
        <Skeleton width={SKELETON_WIDTHS.FULL} />
        <Skeleton width={SKELETON_WIDTHS.FULL} />
        <Skeleton width={SKELETON_WIDTHS.ONE_THIRD} />
      </div>
    </div>
  </div>
);

export default IdeaUpdateCardLoading;
